import { createSelector } from '@reduxjs/toolkit';
import dayjs from 'dayjs';

import { ProjectLayoutModel } from '@paragon/contract-library';

import { RootState } from '../slices';
import { ProjectFiltersState, UNASSIGNED } from '../slices/projectFiltersSlice';
import { getProjects } from './layoutModels';

/** Pure predicate: does a project pass the current search/date/status/assignee filters? */
export function matchesProjectFilters(project: ProjectLayoutModel, filters: ProjectFiltersState): boolean {
  if (filters.status && project.status !== filters.status) return false;

  if (filters.assignee && !matchesAssigneeFilter(project, filters.assignee)) return false;

  if (filters.search) {
    const term = filters.search.toLowerCase().trim();
    const haystacks = [project.name, project.customerName, project.contactName, project.contactEmail];
    if (!haystacks.some((value) => (value ?? '').toLowerCase().includes(term))) return false;
  }

  if (filters.createdMonth) {
    if (dayjs(project.createdAt).format('YYYY-MM') !== filters.createdMonth) return false;
  }

  return true;
}

function matchesAssigneeFilter(project: ProjectLayoutModel, assigneeFilter: string): boolean {
  if (assigneeFilter === UNASSIGNED) return project.assigneeEmail == null;

  return project.assigneeEmail === assigneeFilter;
}

export const getFilteredProjects = createSelector(
  [getProjects, (state: RootState) => state.projectFilters],
  (projects, filters) => projects.filter((project) => matchesProjectFilters(project, filters)),
);

export const getEarliestProjectCreatedDate = createSelector([getProjects], (projects) => {
  if (projects.length === 0) return null;

  return new Date(Math.min(...projects.map((project) => Date.parse(project.createdAt))));
});
